module.exports = __webpack_public_path__ + "media/images/flags/GU-d826a2bbc563bb87a885a228c28a4131.svg";